/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import {
    ExportedPasswordCredential,
    instanceOfExportedPasswordCredential,
    ExportedPasswordCredentialFromJSON,
    ExportedPasswordCredentialFromJSONTyped,
    ExportedPasswordCredentialToJSON,
} from './ExportedPasswordCredential';
import {
    ExportedPublicKeyCredential,
    instanceOfExportedPublicKeyCredential,
    ExportedPublicKeyCredentialFromJSON,
    ExportedPublicKeyCredentialFromJSONTyped,
    ExportedPublicKeyCredentialToJSON,
} from './ExportedPublicKeyCredential';
import {
    ExportedTOTPCredential,
    instanceOfExportedTOTPCredential,
    ExportedTOTPCredentialFromJSON,
    ExportedTOTPCredentialFromJSONTyped,
    ExportedTOTPCredentialToJSON,
} from './ExportedTOTPCredential';

/**
 * @type ExportedCredential
 * 
 * @export
 */
export type ExportedCredential = { type: 'password' } & ExportedPasswordCredential | { type: 'public-key' } & ExportedPublicKeyCredential | { type: 'totp' } & ExportedTOTPCredential;

export function ExportedCredentialFromJSON(json: any): ExportedCredential {
    return ExportedCredentialFromJSONTyped(json, false);
}

export function ExportedCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedCredential {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'password':
            return {...ExportedPasswordCredentialFromJSONTyped(json, true), type: 'password'};
        case 'public-key':
            return {...ExportedPublicKeyCredentialFromJSONTyped(json, true), type: 'public-key'};
        case 'totp':
            return {...ExportedTOTPCredentialFromJSONTyped(json, true), type: 'totp'};
        default:
            throw new Error(`No variant of ExportedCredential exists with 'type=${json['type']}'`);
    }
}

export function ExportedCredentialToJSON(value?: ExportedCredential | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'password':
            return ExportedPasswordCredentialToJSON(value);
        case 'public-key':
            return ExportedPublicKeyCredentialToJSON(value);
        case 'totp':
            return ExportedTOTPCredentialToJSON(value);
        default:
            throw new Error(`No variant of ExportedCredential exists with 'type=${value['type']}'`);
    }

}

